<template>
  <transition-group name="pop"
                    tag="div"
                    class="message-holder">
    <div v-for="msg in all"
         :key="msg.key"
         class="alert alert-dismissable"
         :class="'alert-'+msg.type"
         role="alert">
      <button class="close"
              type="button"
              aria-label="Close"
              @click.prevent="delMsg(msg.key)"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      {{msg.message}}
    </div>
  </transition-group>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapGetters} = createNamespacedHelpers('msg')
  export default {
    name: "message-handler",
    computed: {
      ...mapGetters([
        'all'
      ])
    },
    methods: {
      ...mapMutations([
        'delMsg'
      ])
    },
  }
</script>

<style scoped>
  .message-holder {
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
    z-index: 10000;
  }
  .alert{
    min-width: 50vw;
  }
</style>


// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/top-level/message-handler.vue